module.exports = __webpack_public_path__ + "img/Atelier_6.4b08c7d8.jpg";